import posthtml from 'posthtml/lib';
import { parseStyleString } from './parse-style-string';
const DEFAULT_MJML_FONT_SIZE = '13px';
const updateStyleAttributes = _ref => {
  var _node$attrs, _node$attrs2, _node$attrs3, _node$attrs4, _node$content3;
  let node = _ref.node,
    props = _ref.props;
  if (typeof node === 'string') {
    return;
  }
  const fontSizeAttribute = node == null || (_node$attrs = node.attrs) == null ? void 0 : _node$attrs['font-size'];
  if (!((_node$attrs2 = node.attrs) != null && _node$attrs2.style) && !fontSizeAttribute) {
    var _node$content;
    (_node$content = node.content) == null || _node$content.forEach(child => {
      updateStyleAttributes({
        node: child,
        props
      });
    });
    return;
  }
  const style = (_node$attrs3 = node.attrs) != null && _node$attrs3.style ? parseStyleString(node.attrs.style) : {};
  const fontSize = style.fontSize || fontSizeAttribute || props.inheritedFontSize || DEFAULT_MJML_FONT_SIZE;
  const lineHeight = style.lineHeight;
  if (!lineHeight) {
    var _node$content2;
    node == null || (_node$content2 = node.content) == null || _node$content2.forEach(child => {
      updateStyleAttributes({
        node: child,
        props: {
          inheritedFontSize: fontSize
        }
      });
    });
    return;
  }

  // We assume that the font size is always provided in pixels and only convert the line height if it's given in em.
  // As agreed, we will address support for other uncommon units if we see it as an issue.
  if ((_node$attrs4 = node.attrs) != null && _node$attrs4.style && lineHeight.endsWith('em') && fontSize.endsWith('px')) {
    const lineHeightInPx = parseFloat(lineHeight) * parseFloat(fontSize);
    const lineHeightRounded = lineHeightInPx % 1 === 0 ? lineHeightInPx : lineHeightInPx.toFixed(1);
    const trimmedStyle = node.attrs.style.trim();
    const currentStyle = trimmedStyle.at(-1) === ';' ? trimmedStyle : `${trimmedStyle};`;
    const withMsoStye = currentStyle + ` mso-line-height-alt: ${lineHeightRounded}px; mso-line-height-rule: exactly;`;
    node.attrs.style = withMsoStye;
  }
  node == null || (_node$content3 = node.content) == null || _node$content3.forEach(child => {
    updateStyleAttributes({
      node: child,
      props: {
        inheritedFontSize: fontSize
      }
    });
  });
};
export const addMsoStylesToRawHtml = mjml => {
  const adStyles = tree => {
    tree.match([{
      tag: 'mj-accordion-title'
    }, {
      tag: 'mj-accordion-text'
    }, {
      tag: 'mj-button'
    }, {
      tag: 'mj-carousel-image'
    }, {
      tag: 'mj-navbar-link'
    }, {
      tag: 'mj-raw'
    }, {
      tag: 'mj-social'
    }, {
      tag: 'mj-table'
    }, {
      tag: 'mj-text'
    }], node => {
      updateStyleAttributes({
        node,
        props: {
          inheritedFontSize: undefined
        }
      });
      return node;
    });
  };
  const withUpdatedStyle = posthtml([adStyles]).process(mjml, {
    sync: true,
    xmlMode: true
  });
  return withUpdatedStyle.html;
};
//# sourceMappingURL=add-mso-styles.js.map